<template>
  <section-page title="Email Integration">
    <app-upgrade-required class="mt-400" is-centered is-large/>
  </section-page>
</template>

<script>
import AppUpgradeRequired from "../../components/app/AppUpgradeRequired.vue";

export default {
  name: "EmailSettingsNotAvailableTab",
  components: { AppUpgradeRequired }
};
</script>
